import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocumentGatewayService
{

  constructor(private http: HttpClient)
  {
  }

  public sendQueryDocumentRequest(memberId: number): Observable<any>
  {
    return this.http.post<any>(`/documents/gateway/query/member/${memberId}`, null);
  }

  public getLastQueryDocument(memberId: number): Observable<any>
  {
    return this.http.get<any>(`/documents/gateway/query/status/member/${memberId}`);
  }

  public getQueryDocumentResults(memberId: number): Observable<any>
  {
    return this.http.get<any>(`/documents/gateway/query/results/member/${memberId}`);
  }

  public saveDocumentReference(documentUrl: string): Observable<any>
  {
    return this.http.post<any>(`${documentUrl}/save`, null);
  }
}
